import { createContext, ReactNode, useContext } from 'react';

const ListCountContext = createContext<number | undefined>(undefined);

export const ListCountProvider = ({
  count,
  children,
}: {
  count: number | undefined;
  children: ReactNode;
}) => (
  <ListCountContext.Provider value={count}>
    {children}
  </ListCountContext.Provider>
);

export const useListCount = () => useContext(ListCountContext);
